/**
 * Special version of DrsController for Angular upgrade
 * The prefix "zng1-" is required!
 */
namespace h5_client {
   module platform_ui {

      declare const h5: any;
      declare const angular: ng.IAngularStatic;

      export class SearchViewComponent implements ng.IComponentOptions {

         bindings: any = {
            objectId: "<"
         };

         // Uses legacy template
         template:string='<div class="fill-parent simple-search"> <search-center-pane class="simple-search"></search-center-pane> </div>';
         controller = h5.ngMigrationDefaultCompatibilityController();
      }

      angular.module('com.vmware.platform.ui')
         .component('searchView', new SearchViewComponent());
   }
}
